import { IndicatorOrTag } from "@/modules/DashboardTemplate/models/IndicatorOrTag";
import { PropertiesToChart } from "@/modules/DashboardTemplate/models/PropertiesToChart";
import { ResizeEventPayload } from "@/modules/DashboardTemplate/models/resizeEventPayload";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import DraggableWrapper from "../../DraggableWrapper/DraggableWrapper.vue";
import DashboardViewCollection from "../DashboardViewCollection/DashboardViewCollection.vue";
import { SectionsToChart } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import FilterSectionModal from "../../FilterSectionModal/FilterSectionModal.vue";

@Component({
  name: "DashboardViewSection",
  components: {
    DashboardViewCollection,
    DraggableWrapper,
    FilterSectionModal
  }
})
export default class DashboardViewSection extends Vue {
  @Prop() realDashboard?: boolean;

  @Prop({ required: true }) section!: SectionsToChart;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  showFilterSection = false;

  openFilter(indexCollection: number) {
    this.$emit("openFilter", indexCollection);
  }
  onChartTypeChanged(newChartType: string, indexCollection: number) {
    const newPropertiesToChart = [...this.section.propertiesToChart];
    const propertiesToChart = newPropertiesToChart[
      indexCollection
    ] as PropertiesToChart;
    if (propertiesToChart.type !== "chart") return;
    if (propertiesToChart.chartType === newChartType) return;
    propertiesToChart.chartType = newChartType;
    this.UpdatePropertiesToChart(newPropertiesToChart);
  }
  onChildResize(payload: ResizeEventPayload) {
    let { width, height } = payload;
    const rootEl = this.$el as HTMLElement | null;
    if (!rootEl) return;
    const wrapper = rootEl.querySelector<HTMLElement>(
      ".section-container .draggable-wrapper, .section-container .dynamic-wrapper"
    );

    if (wrapper) {
      const sectionRect = rootEl.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();
      const topDiff = wrapperRect.top - sectionRect.top;
      const leftDiff = wrapperRect.left - sectionRect.left;
      width += leftDiff;
      height += topDiff;
    }
    const padding = 16;
    width += padding * 2;
    height += padding * 2;
    this.$emit("resizeMinimum", { width, height });
  }
  UpdatePropertiesToChart(
    newPropertiesToChart: (PropertiesToChart | IndicatorOrTag)[]
  ) {
    this.$emit("update:propertiesToChart", newPropertiesToChart);
  }

  openFilterSection() {
    this.showFilterSection = true;
  }

  makeQueryWithAllFiltersSection() {
    this.showFilterSection = false;
    this.$emit("makeQueryWithAllFiltersSection", this.section.index, -1, true);
  }
}
